<template>
	<!-- <div v-show="show" @click="close()">
		<div class="emotion-box" :style="{ 'left': x + 'px', 'top': y + 'px' }">
			<el-scrollbar style="height: 220px">
				<div class="emotion-item-list">
					<div class="emotion-item" v-for="(emoText, i) in $emo.emoTextList" :key="i"
						@click="onClickEmo(emoText)" v-html="$emo.textToImg(emoText,'emoji-large')">
					</div>
				</div>
			</el-scrollbar>
		</div>
	</div> -->
	<div v-show="show" class="mask" @click="close()">
		<div class="emotion-box" :style="{ 'left': x + 'px', 'top': y + 'px' }" @click.stop>
			<el-scrollbar style="height: 220px">
				<div class="emotion-item-list">
					<div class="emotion-item" v-for="(emoText, i) in $emo.yanWordList[tabIndex]" :key="i"
						@click="onClickEmo(emoText)">
						{{ emoText }}
					</div>
				</div>
			</el-scrollbar>
			<div class="tab-list">
				<div class="tab-item" v-for="(tab, i) in tabList" :key="i" :class="i == tabIndex ? 'tab-active' : ''" @click="tabIndex = i">
					{{ tab }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "emotion",
	data() {
		return {
			show: false,
			pos: {
				x: 0,
				y: 0
			},
			tabList: ['常用', '表情/人物', '自然/动物', '活动', '食物/饮料', '旅游', '旗帜'],
			tabIndex: 0,
		}
	},
	methods: {
		onClickEmo(emoText) {
			// let emotion = `#${emoText};`
			this.$emit('emotion', emoText)
		},
		open(pos) {
			this.pos = pos;
			this.show = true;
		},
		close() {
			this.show = false;
		}
	},
	computed: {
		x() {
			return this.pos.x - 22;
		},
		y() {
			return this.pos.y - 264;
		}
	}
}
</script>
<style scoped lang="scss">
.mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.emotion-box {
	position: fixed;
	width: 362px;
	box-sizing: border-box;
	padding: 5px;
	//border-radius: 5px;
	background-color: #fff;
	box-shadow: var(--im-box-shadow);
	z-index: 1001;
	.emotion-item-list {
		display: flex;
		flex-wrap: wrap;
		.emotion-item {
			text-align: center;
			cursor: pointer;
			padding: 1px;
			font-size: 22px;
			font-family: "Twemoji Country Flags", "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif;
			border: 1px solid transparent;
			border-radius: 50%;
			&:hover {
				border-color: #999;
			}
		}
	}

	//&:after {
	//	content: "";
	//	position: absolute;
	//	left: 185px;
	//	bottom: -30px;
	//	width: 0;
	//	height: 0;
	//	border-style: solid dashed dashed;
	//	border-color: #f5f5f5 transparent transparent;
	//	overflow: hidden;
	//	border-width: 15px;
	//}
	.tab-list {
		display: flex;
		background-color: #f5f5f5;
		padding: 5px 0;
		overflow-y: auto;
		gap: 6px;
		.tab-item {
			cursor: pointer;
			font-size: 13px;
			word-break: keep-all;
			width: fit-content;
			padding: 2px;
			border-radius: 4px;
		}
	}
	.tab-active {
		background-color: #000;
		color: #fff;
	}
}
</style>
